
import React from 'react';
import Layout from '@/components/Layout';

const ComingSoon: React.FC = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 text-center">
        <h1 className="text-3xl font-bold mb-6">Coming Soon</h1>
        <p className="mb-4">This feature is currently under development and will be available soon!</p>
        <div className="mt-8 text-6xl">🚧</div>
      </div>
    </Layout>
  );
};

export default ComingSoon;
